export default "__VITE_ASSET__05adc0fd__"